import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import CompeteIcon from '../COMPONENTS/CompeteIcon';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import PauseIcon from '../../HOME/SVG/PauseIcon';
import { showLeaderboards, requestSurrender, requestResetStats, goToPage } from '../../HOME/REDUX/actions';
import { setScore, setLevel, setStartLevel, pause, setLoadingGame } from '../REDUX/actions';
import { setLevelsCompleted, setIntroduced, setMode } from '../REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { PRACTICE, COMPETE } from '../const';
import * as f from '../logic';
import { RED } from '../../HOME/const';

class Toolbar extends Component {
  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleSurrender = e => {
    if (!this.canSurrender()) {
      return;
    }

    this.handlePause();
    this.props.hideOptions();
    this.props.requestSurrender(true);
    this.props.requestResetStats(false);
  };

  canSurrender = () => {
    const { hits, misses } = this.props;
    return (hits > 0 || misses > 0) && misses < 3;
  };

  handleLeaders = () => {
    this.handlePause();
    this.props.hideOptions();
    this.props.showLeaderboards();
  };

  handlePause = () => {
    if (this.props.timeLeft > 0) {
      this.props.pause(true);
    }
  };

  handleOptions = () => {
    if (this.props.mode === COMPETE) {
      this.handlePause();
    }

    this.props.onClickOptions();
  };

  render() {
    const { mode } = this.props;
    const xmax = windowSize().x;
    const margin = Math.max(5, Math.min(10, xmax / 100));

    const styles = {
      button: { marginLeft: margin, marginRight: margin },
    };

    return (
      <div className="toolbar">
        <span>
          {mode === COMPETE && !this.props.paused ? (
            <span
              className={`toolbar-button ${this.props.timeLeft > 0 && !this.props.intro ? '' : 'toolbar-button-disabled'}`}
              style={styles.button}
              onClick={this.handlePause}>
              <PauseIcon width="36" color={RED} />
            </span>
          ) : null}
          {mode === PRACTICE ? (
            <span className={`toolbar-button`} style={styles.button} onClick={() => f.onCompete(this.props)}>
              <CompeteIcon width="36" />
            </span>
          ) : null}
          {mode === COMPETE ? (
            <span
              className={`toolbar-button${this.canSurrender() ? '' : ' toolbar-button-disabled'}`}
              style={styles.button}
              onClick={this.handleSurrender}>
              <RestartIcon width="36" />
            </span>
          ) : null}
          {mode === COMPETE ? (
            <span className="toolbar-button" style={styles.button} onClick={this.handleLeaders}>
              <TrophyIcon width="36" />
            </span>
          ) : null}
          <span className="toolbar-button" style={styles.button} onClick={this.handleOptions}>
            <OptionsIcon width="36" id="options-button" />
          </span>
        </span>
      </div>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  {
    requestResetStats,
    requestSurrender,
    showLeaderboards,
    goToPage,
    setScore,
    setLevel,
    setStartLevel,
    setLevelsCompleted,
    setMode,
    setIntroduced,
    pause,
    setLoadingGame,
  }
)(Toolbar);
